import { Trans } from '@lingui/react/macro';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import React from 'react';
import { AsyncState } from 'shared/utils/async-state';
import UDAsyncContent from 'ud-ui/components/async-content';
import UDText from 'ud-ui/components/text';
// Не из барреля: `user-info/index.ts` делает `export *`, а компонент экспортирован только по умолчанию.
import UserInfo from 'ud-ui/components/user-info/user-info';
import LanguageSelect from './language-select';

const LOADING: AsyncState = { status: 'loading', isRefreshing: false };
const READY: AsyncState = { status: 'ready', isRefreshing: false };

interface AccountFieldProps {
  label: React.ReactNode;
  value?: string | null;
}

function AccountField({ label, value }: AccountFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <UDText type="footnote" className="text-inkSecondary">
        {label}
      </UDText>
      <UDText type="subhead">{value || '—'}</UDText>
    </div>
  );
}

/**
 * Личный кабинет: данные текущего пользователя (только чтение — эндпойнта обновления себя нет)
 * и язык интерфейса. Язык хранится только в браузере: на бэкенде для него нет поля.
 */
function Account() {
  const { user } = useAuth();
  const fullName = user ? [user.surname, user.name, user.middleName].filter(Boolean).join(' ') : '';

  return (
    <div className="flex flex-col gap-6">
      <UDText type="headline" className="block">
        <Trans>Личный кабинет</Trans>
      </UDText>

      {/* Выбор языка — вне ветки загрузки: он не зависит от пользователя. */}
      <UDAsyncContent state={user ? READY : LOADING} minHeight={120}>
        {user && (
          <div className="flex flex-col gap-4">
            <UserInfo avatar={user.photo || undefined} title={fullName} />
            <AccountField label={<Trans>Телефон</Trans>} value={user.phone} />
            <AccountField label={<Trans>Электронная почта</Trans>} value={user.email} />
          </div>
        )}
      </UDAsyncContent>

      <LanguageSelect className="max-w-xs" />
    </div>
  );
}

export default Account;
